module.exports = __webpack_public_path__ + "img/image41.d8d1d4a6.jpg";